import { useState, useEffect } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

interface InventoryStatsProps {
  total: number;
  lowStock?: number;
  outOfStock?: number;
  onManageCategories?: () => void;
}

const InventoryStats: React.FC<InventoryStatsProps> = ({
  total,
  lowStock,
  outOfStock,
  onManageCategories,
}) => {
  const [expanded, setExpanded] = useState(true);

  // ✅ Hide inventory summary by default on mobile devices (screen width < 1024px).
  // Users can still expand it manually using the toggle button.
  useEffect(() => {
    if (window.innerWidth < 1024) {
      setExpanded(false);
    }
  }, []);

  return (
    <div className="space-y-2">
      {/* Header with toggle */}
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
          <span className="inline-block w-1.5 h-5 bg-blue-600 rounded"></span>
          Stock Overview
        </h2>
        <button
          onClick={() => setExpanded(!expanded)}
          className="p-1 rounded hover:bg-gray-100 transition"
        >
          {expanded ? (
            <span>{FaChevronUp({ size: 14 })}</span>
          ) : (
            <span>{FaChevronDown({ size: 14 })}</span>
          )}
        </button>
      </div>

      {/* Stats Grid */}
      {expanded && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-blue-100 p-4 rounded-xl">
            <p className="text-sm text-gray-600">Total</p>
            <p className="text-xl font-bold">{total}</p>
          </div>

          {typeof lowStock === "number" && (
            <div className="bg-yellow-100 p-4 rounded-xl">
              <p className="text-sm text-gray-600">Low Stock (&lt;10)</p>
              <p className="text-xl font-bold">{lowStock}</p>
            </div>
          )}

          {typeof outOfStock === "number" && (
            <div className="bg-red-100 p-4 rounded-xl">
              <p className="text-sm text-gray-600">Out of Stock</p>
              <p className="text-xl font-bold">{outOfStock}</p>
            </div>
          )}

          {onManageCategories && (
            <div
              onClick={onManageCategories}
              className="cursor-pointer bg-gray-100 hover:bg-gray-200 transition p-4 rounded-xl flex flex-col justify-center items-center text-center border border-dashed border-gray-400"
            >
              <span className="text-3xl">📂</span>
              <p className="font-semibold mt-2">Manage Categories</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InventoryStats;
